import React, { useEffect, useContext } from 'react';
import { SVBTypography } from '@svb/svb-react-components';
import { detailsContext } from './context/DetailsProvider';

const SolutionDetailsHowItWorks = ({ children, title}) => {
  const { addTitle, idGenerator } = useContext(detailsContext);
  useEffect(() => {
    addTitle(title);
  }, [title]);
  return (
    <section
      className="solutions_solutionDetails_hiw_wrapper"
      id={idGenerator(title)}
    >
      <SVBTypography type="heading-large" variant="mb-4">{title}</SVBTypography>
      {children.map((howItWorksObj, index) => {
        return (
          <div key={index} className="how-it-works-section-bottom-content row m-1">
            <div className="how-it-works-section-content-number col-2">
              <span className="how-it-works-section-content-number-text" style={{
                color: '#fff',
              }}>
                {index+1}
              </span>
            </div>
            <div className="how-it-works-section-content-number-text-description col-10" style={{
              color: 'inherit',
            }}>
              {howItWorksObj}
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default SolutionDetailsHowItWorks;
